import {
    DiscountType,
    SalesStatus,
    TimeSlot,
} from '../../../state/infiniteCalendarSeries';

export const mockData: TimeSlot[] = [
    {
        id: 'session_morning_1',
        startDatetime: '2025-03-01T02:30:00Z', // 8:00 AM IST
        endDatetime: '2025-03-01T04:30:00Z', // 10:00 AM IST
        salesStatus: SalesStatus.onSale,
        urgencySignals: {
            fewTickets: true,
            salesEndSoon: false,
            new: false,
            popular: false,
            goingFast: false,
        },
        discount: {
            discountType: DiscountType.percentage,
            discountValue: 20,
        },
    },
    {
        id: 'session_morning_2',
        startDatetime: '2025-03-01T03:00:00Z', // 8:30 AM IST
        endDatetime: '2025-03-01T03:30:00Z', // 09:00 AM IST
        salesStatus: SalesStatus.soldOut,
        urgencySignals: {
            fewTickets: false,
            salesEndSoon: false,
            new: true,
            popular: false,
            goingFast: false,
        },
        discount: {
            discountType: DiscountType.fixed,
            discountValue: 20,
        },
    },
    {
        id: 'session_morning_3',
        startDatetime: '2025-03-01T03:00:00Z', // 9:00 AM IST
        endDatetime: '2025-03-01T05:00:00Z', // 10:30 AM IST
        salesStatus: SalesStatus.notOnSale,
        urgencySignals: {
            fewTickets: false,
            salesEndSoon: false,
            new: false,
            popular: true,
            goingFast: false,
        },
        discount: {
            discountType: DiscountType.percentage,
            discountValue: 20,
        },
    },
    {
        id: 'session_morning_4',
        startDatetime: '2025-03-01T03:00:00Z', // 8:30 AM IST
        endDatetime: '2025-03-01T04:30:00Z', // 09:00 AM IST
        salesStatus: SalesStatus.onSale,
        urgencySignals: {
            fewTickets: false,
            salesEndSoon: false,
            new: true,
            popular: false,
            goingFast: false,
        },
        discount: {
            discountType: DiscountType.fixed,
            discountValue: 20,
        },
    },

    {
        id: 'session_afternoon_1',
        startDatetime: '2025-03-01T06:30:00Z', // 12:00 PM IST
        endDatetime: '2025-03-01T08:30:00Z', // 2:00 PM IST
        salesStatus: SalesStatus.notOnSale,
        urgencySignals: {
            fewTickets: false,
            salesEndSoon: false,
            new: false,
            popular: true,
            goingFast: false,
        },
        discount: {
            discountType: DiscountType.percentage,
            discountValue: 20,
        },
    },
    {
        id: 'session_afternoon_2',
        startDatetime: '2025-03-01T07:00:00Z', // 12:30 PM IST
        endDatetime: '2025-03-01T07:30:00Z', // 1:00 PM IST
        salesStatus: SalesStatus.onSale,
        urgencySignals: {
            fewTickets: false,
            salesEndSoon: false,
            new: true,
            popular: false,
            goingFast: false,
        },
        discount: {
            discountType: DiscountType.fixed,
            discountValue: 20,
        },
    },
    {
        id: 'session_afternoon_3',
        startDatetime: '2025-03-01T07:30:00Z', // 1:00 PM IST
        endDatetime: '2025-03-01T09:00:00Z', // 2:30 PM IST
        salesStatus: SalesStatus.notOnSale,
        urgencySignals: {
            fewTickets: false,
            salesEndSoon: false,
            new: false,
            popular: false,
            goingFast: true,
        },
        discount: {
            discountType: DiscountType.percentage,
            discountValue: 20,
        },
    },

    // Night Session (IST 8:00 PM - 10:00 PM, which is UTC 2:30 PM - 4:30 PM)
    {
        id: 'session_night_1',
        startDatetime: '2025-03-01T14:30:00Z', // 8:00 PM IST
        endDatetime: '2025-03-01T16:30:00Z', // 10:00 PM IST
        salesStatus: SalesStatus.onSale,
        urgencySignals: {
            fewTickets: false,
            salesEndSoon: false,
            new: false,
            popular: true,
            goingFast: true,
        },
        discount: {
            discountType: DiscountType.fixed,
            discountValue: 20,
        },
    },
    {
        id: 'session_night_2',
        startDatetime: '2025-03-01T15:30:00Z', // 9:00 PM IST
        endDatetime: '2025-03-01T17:30:00Z', // 11:00 PM IST
        salesStatus: SalesStatus.onSale,
        urgencySignals: {
            fewTickets: true,
            salesEndSoon: false,
            new: false,
            popular: true,
            goingFast: false,
        },
        discount: {
            discountType: DiscountType.percentage,
            discountValue: 20,
        },
    },
];
